
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"21","viewBox":"0 0 21 21"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-1129.037 -369.529)"}},[_c('circle',{attrs:{"cx":"10.5","cy":"10.5","r":"10.5","transform":"translate(1129.037 369.529)","fill":"#bac1cc"}}),_c('path',{attrs:{"d":"M1143.081 379.259h-2.619a.154.154 0 01-.154-.154v-2.619a.77.77 0 00-1.541 0v2.619a.154.154 0 01-.154.154h-2.619a.77.77 0 000 1.541h2.619a.154.154 0 01.154.154v2.619a.77.77 0 001.541 0v-2.619a.154.154 0 01.154-.154h2.619a.77.77 0 000-1.541zm0 0","fill":"#fff"}})])])
          )
        }
      }
    